import './courseDetails.scss'
import BranchIcon from '../../../assets/icons/BranchIcon.svg'
import dateIcon from '../../../assets/icons/TimeTable.svg'
import AccordianCourseDetail from '../../../components/accordion/AccordianCourseDetail'
import RightDrawer from '../../../components/drawer/Drawer'
import { useEffect, useState } from 'react'
import QuizeTopicSelect from '../../../components/quizeTopicSelect/QuizeTopicSelect'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import { ROUTES_PATH, UI_CONSTANT } from '../../../utility/constants'
import paidIcon from '../../../assets/icons/paid-icon.svg'
import { useDispatch, useSelector } from 'react-redux'
import { getStudentCourse } from '../../../store/builders/studentCourse/studentCourse.builder'
import { capitalizeAllLetter, convertTZToDate } from '../../../utility/genricFunction'
import { useParams } from 'react-router-dom'
import Loader from '../../../components/loader/Loader'

function CourseDetails() {
  const dispatch = useDispatch()
  const studentId = useSelector((state) => state?.auth?.user?.result?.studentId)
  const { studentCourseData,loading } = useSelector((state) => state.studentCourse)
  const [open, setOpen] = useState(false)
  const { id } = useParams()
  const courseData = studentCourseData.find((item) => item.courseId === id)
 
  

  useEffect(() => {
    dispatch(getStudentCourse(studentId))
  }, [dispatch, studentId])

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.STUDENT_DASHBOURD.COURSE_DETAILS,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.STUDENT_DASHBOARD,
    },
    {
      title: UI_CONSTANT.STUDENT_DASHBOURD.COURSE_DETAILS,
      link: ROUTES_PATH.STUDENT_COURSE_DETAILS,
    },
  ]

  function getStatus(paymentArray) {
    if (paymentArray?.length === 1) {
      const payment = paymentArray[0]
      if (payment?.paymentOn) {
        return `paid at ${convertTZToDate(payment?.paymentOn)}`
      } else if (payment.paymentDue) {
        return `due at ${convertTZToDate(payment?.paymentDue)}`
      }
    } else if (paymentArray?.length > 1) {
      let dueDate = null
      let paidDate = null
      for (const payment of paymentArray) {
        if (payment?.paymentDue) {
          dueDate = payment?.paymentDue
        } else if (payment?.paymentOn) {
          paidDate = payment?.paymentOn
        }
      }
      if (dueDate) {
        return `due at ${convertTZToDate(dueDate)}`
      } else if (paidDate) {
        return `paid at ${convertTZToDate(paidDate)}`
      }
    }
    return null
  }

  return (

    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> &&<div className='studentDashboard-courseDetails-wrapper'>
      <div className='studentDashboard-courseDetails-header'>
        <div className='subheader'>
          <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
        </div>
        <RightDrawer anchor='right' isOpen={open} onClose={toggleDrawer(false)}>
          <QuizeTopicSelect onclose={toggleDrawer} data={courseData?.modules} />
        </RightDrawer>
        <button className='start-practice-btn' onClick={toggleDrawer(true)}>
          Start Practice
        </button>
      </div>

      <div className='studentCourse-detail-wrapper'>
        <div className='courseDetail-left-div'>
          <div className='courseDetail-header'>
            <div className='courseDetail-header-exam flex'>
              {courseData?.courseExamFormat?.map((item) => (
                <span className='mcq-div' key={item}>{capitalizeAllLetter(item)}</span>
              ))}
            </div>
            <p>{courseData?.courseName}</p>
          </div>

          <div className='course-branchDetails'>
            <span>
              <img src={BranchIcon} alt='branchIcon' /> {`${courseData?.area || 'N/A'}, ${courseData?.city || 'N/A'}`}
            </span>
            <span>
              <img src={dateIcon} alt='dateIcon' />{' '}
              {`Start: ${convertTZToDate(courseData?.batchStartDate)} - End: ${convertTZToDate(courseData?.batchEndDate)}`}
            </span>
          </div>

          <div className='courseDetail-footer'>
            <div className='course-card-details'>
              <span>{courseData?.totalModuleCount}</span> Modules <div className='saprater-div'></div>
              <span>{courseData?.totalTopicCount}</span> Topics <div className='saprater-div'></div>
              <span>{courseData?.totalDocumentCount}</span> PDF <div className='saprater-div'></div>
              <span>{courseData?.totalMcqCount}</span> MCQ <div className='saprater-div'></div>
              <span>{courseData?.totalDescriptiveCount}</span> Descriptive
            </div>
          </div>
        </div>

        <div className='courseDetail-right-div'>
          <p>₹{courseData?.courseFees}</p>
          <p className='payment-date'>
            {getStatus(courseData?.paymentHistory)?.slice(0, 1) !== 'd' && <img src={paidIcon} alt='paid icon' />}
            {getStatus(courseData?.paymentHistory)}
          </p>
        </div>
      </div>

      <div className='course-content-wrapper'>
        <div className='course-content-header'>
          <p>Course Content</p>
        </div>

        <div className='course-content-accordion-wrapper'>
          <AccordianCourseDetail courseData={courseData} />
        </div>
      </div>
    </div>}
    </>
    
  )
}

export default CourseDetails
